import React from "react";
import TextInput from "./TextInput";
import { t } from "i18next";
import { LocationCreateUpdateDto } from "./ObjectTypes";

type LatLonAltCoordinateInputProps = {
  location: LocationCreateUpdateDto;
  errors: any;
  className: string;
  onChange: (event: any) => void;
  onKeyPress?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  onBlur?: (event: any) => void;
  disabled: boolean;
};

const LatLonAltCoordinateInput: React.FC<LatLonAltCoordinateInputProps> = ({
  location,
  className,
  errors,
  onChange,
  onKeyPress,
  onBlur: onBlurFromParent,
  disabled,
}) => {
  const setLatitudePrecision = () => {
    if (location.latitude) {
      const e = {
        target: {
          name: "latitude",
          value: Number(location.latitude).toFixed(6),
        },
      };
      onChange(e);
    }
  };

  const setLongitudePrecision = () => {
    if (location.longitude) {
      const e = {
        target: {
          name: "longitude",
          value: Number(location.longitude).toFixed(6),
        },
      };
      onChange(e);
    }
  };

  /*
   * Sets the precision of the latitude and longitude fields and executes the onBlur event from the parent component.
   */
  const onBlur = (e: any) => {
    if (e.target.name === "latitude") {
      setLatitudePrecision();
    } else if (e.target.name === "longitude") {
      setLongitudePrecision();
    }
    if (onBlurFromParent) {
      onBlurFromParent(e);
    }
  };

  return (
    <div className="grid grid-cols-2 gap-3 ">
      <TextInput
        name="latitude"
        label={t("Latitude") + " (°)*"}
        value={location.latitude == null ? "" : location.latitude.toString()}
        onChange={onChange}
        error={errors.latitude}
        className={className}
        placeholder={t("Enter Latitude in decimal degrees")}
        type="number"
        limit={10}
        disabled={disabled}
        onBlur={(event) => onBlur(event)}
        onKeyPress={onKeyPress}
      />
      <TextInput
        name="longitude"
        label={t("Longitude") + " (°)*"}
        value={location.longitude == null ? "" : location.longitude.toString()}
        onChange={onChange}
        error={errors.longitude}
        className={className}
        placeholder={t("Enter Longitude in decimal degrees")}
        type="number"
        disabled={disabled}
        onBlur={(event) => onBlur(event)}
        onKeyPress={onKeyPress}
        limit={11}
      />
    </div>
  );
};

export default LatLonAltCoordinateInput;
